export default __webpack_public_path__ + "assets/a0eeb3af7a8f8832236fde2401e72b9d/06.jpg";